export const attachmentIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26" fill="white"/>
<path d="M15.5096 8V16.5609C15.5096 17.6318 14.6415 18.5 13.5705 18.5V18.5C12.4996 18.5 11.6314 17.6318 11.6314 16.5609V6.6843C11.6314 4.64952 13.2809 3 15.3157 3V3C17.3505 3 19 4.64952 19 6.6843V17.5C19 20.5376 16.5376 23 13.5 23V23C10.4624 23 8 20.5376 8 17.5V8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
`;
